import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Checkbox, Form, message, Modal, Select, Space, Tooltip } from 'antd';
import UpdateDomainModal from 'component/update_domain';
import { SweetSweetAlert } from 'component/sweetalert_components';
import TableComponent from 'component/table_component/antTable/table';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { deleteDomain, getDomainData, updatePrimaryDomain } from 'redux/slices/domainSlice';
import { AdminPageSizeWrap, AdminPageWrap, AdminTitleWrap } from './style';
import { SpanButton } from 'component/button_components/button.style';
import CustomPagination from 'component/table_component/antTable/pagenation';
import { ReactComponent as DeleteIcon } from 'assets/images/SVG/icons/delete-icon.svg';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import TableLoader from 'component/loader_component/tableLoader';
import DomainSettingsModal from 'component/modal_components/domain_settings';
import { ReactComponent as TickIcon } from 'assets/images/SVG/icons/tick-icon.svg';
import { ReactComponent as CancelIcon } from 'assets/images/SVG/icons/cancel-icon.svg';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { getDropDownGroupData, setGroupSelectedItems } from 'redux/slices/getOuGroups';
import { FormLabel } from 'pages/settings_page/style';
import { logout } from 'redux/slices/authSlice';
import { setSelectedItems } from 'redux/slices/userSlice';
import { resetDomainState } from 'redux/slices/selectedNodeSlice';
import { resetTreeState } from 'redux/slices/treedata';
import { resetOuTreeState } from 'redux/slices/ouAdminTree';

function AdminPage() {
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const [isPrimaryDomainForm] = Form.useForm();
  const { domainFromApi, loading } = useSelector((state) => state.domainData);
  const [loader, setLoader] = useState(false);
  // Initialize state for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  let dataToShow = domainFromApi && domainFromApi.slice(startIndex, endIndex);
  const dropDownGroupData = useSelector((state) => state.getOuGroupData.dropDownData);
  const [openModalDomain, setOpenModalDomain] = useState(null);
  const { licenseDetails } = useSelector((state) => state.licenseSlice);

  const handleOpenModal = async (record) => {
    setLoader(true);
    const groupdata = await dispatch(
      getDropDownGroupData({
        ouName: record.distinguishedName,
        fqdn: record.fqdn,
      })
    );
    if (groupdata.payload) {
      isPrimaryDomainForm.setFieldsValue({
        isPrimaryDomain: record.isPrimaryDomain,
        superAdmin: record?.superAdmin ? record.superAdmin : null,
      });
      setOpenModalDomain(record);
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setOpenModalDomain(null);
  };
  const handlelogout = async () => {
    await dispatch(logout());
    dispatch(setSelectedItems([]));
    dispatch(setGroupSelectedItems([]));
    dispatch(resetDomainState());
    dispatch(resetTreeState());
    dispatch(resetOuTreeState());
    Navigate('/login');
    setOpenModalDomain(null);
  };

  if (dataToShow) {
    dataToShow = dataToShow.sort((a, b) => b.isPrimaryDomain - a.isPrimaryDomain);
  } else {
    dataToShow = [];
  }

  useEffect(() => {
    dispatch(getDomainData());
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [domainFromApi]);

  const onFinish = async (values) => {
    try {
      setLoader(true);
      const response = await dispatch(updatePrimaryDomain({ values: values, id: openModalDomain.id }));
      if (response?.payload.status === 200) {
        if (openModalDomain.isPrimaryDomain !== values.isPrimaryDomain) {
          await SweetSweetAlert({
            sweetData: 'Your primary domain has been switched. You have to login back now.',
            icon: 'success',
            buttonColor: 'green',
          });

          handlelogout();
        } else if (openModalDomain.isPrimaryDomain && openModalDomain.superAdmin !== values.superAdmin) {
          await SweetSweetAlert({
            sweetData: 'Your SuperAdmin group has been changed. You have to login back now.',
            icon: 'success',
            buttonColor: 'green',
          });

          handlelogout();
        } else {
          await SweetSweetAlert({ sweetData: response.payload.data, icon: 'success', buttonColor: 'green' });
          setOpenModalDomain(null);
          dispatch(getDomainData());
        }
      } else if (response?.payload.status === 400) {
        SweetSweetAlert({ sweetData: response.payload.data, icon: 'error', buttonColor: 'red' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      return error;
    } finally {
      setLoader(false);
    }
  };
  const onCheckboxChange = async (e) => {
    if (e.target.checked) {
      const result = await Swal.fire({
        icon: 'info',
        text: 'Are you sure you want to change your primary domain?',
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        showCancelButton: true,
        cancelButtonColor: 'green',
        width: '400px',
        heightAuto: false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          container: 'custom-swal-container',
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });
      if (result.isConfirmed) {
        isPrimaryDomainForm.setFieldsValue({
          isPrimaryDomain: true,
        });
      } else {
        isPrimaryDomainForm.setFieldsValue({
          isPrimaryDomain: false,
        });
      }
    } else {
      message.info('Your primary domain will not be switched.');
      isPrimaryDomainForm.setFieldsValue({
        isPrimaryDomain: false,
      });
    }
  };

  const deleteDomainSweetAlert = async (id) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure you want to delete?',
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
    });

    if (result.isConfirmed) {
      setLoader(true);
      try {
        const sweetAlert = await dispatch(deleteDomain(id));
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
          dispatch(getDomainData());
        } else if (sweetAlert.payload.status === 400) {
          SweetSweetAlert({ text: sweetAlert.payload.data, icon: 'error', buttonColor: 'red' });
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoader(false);
      }
    }
  };

  const columns = [
    {
      title: 'Domain Name',
      dataIndex: 'domainName',
    },
    {
      title: 'Super Admin',
      dataIndex: 'superAdminName',
    },
    {
      title: 'Domain Admin',
      dataIndex: 'portalName',
    },
    {
      title: 'OU Admin',
      dataIndex: 'ouName',
    },
    {
      title: 'Primary Domain',
      dataIndex: 'isPrimaryDomain',
      render: (_, record) => (
        <>
          <Tooltip title={record.isPrimaryDomain ? 'Update SuperAdmin' : 'Make as Primary Domain'} color='#597081'>
            <SpanButton onClick={() => handleOpenModal(record)}>
              {record.isPrimaryDomain ? <TickIcon /> : <CancelIcon />}
            </SpanButton>
          </Tooltip>
          {openModalDomain?.id === record.id && (
            <Modal open={openModalDomain?.id === record.id} onCancel={handleCancel} footer={[null]} centered>
              <div className='af-modal-wrap af-modal-wrap-isPrimaryDomain emaildelivery'>
                <h2 className='af-form-header af-isPrimaryDomain-form-header'>
                  {record.isPrimaryDomain ? 'Update SuperAdmin' : 'Make as Primary Domain'}
                </h2>
                <Form
                  className='af-form af-isPrimaryDomain-form'
                  name='isPrimaryDomain'
                  form={isPrimaryDomainForm}
                  onFinish={onFinish}
                  initialValues={{
                    isPrimaryDomain: record?.isPrimaryDomain,
                    superAdmin: record ? record?.superAdmin : null,
                  }}
                  size='large'
                  scrollToFirstError
                >
                  <FormLabel
                    name='isPrimaryDomain'
                    className='formItemEvenLine af-form-item af-isPrimaryDomain-form-item af-isPrimaryDomain-form-item-PrimaryDomain'
                    label='PrimaryDomain:'
                    valuePropName='checked'
                    extra='* Clicking on this checkbox makes the Domain as Primary domain *'
                  >
                    <Checkbox
                      disabled={record.isPrimaryDomain}
                      onChange={onCheckboxChange}
                      className='af-form-input af-isPrimaryDomain-form-input af-isPrimaryDomain-form-checkbox-PrimaryDomain'
                    >
                      Mark as Primary
                    </Checkbox>
                  </FormLabel>
                  <FormLabel
                    name='superAdmin'
                    className='formItemEvenLine af-form-item af-isPrimaryDomain-form-item af-isPrimaryDomain-form-item-superAdmin'
                    label='SuperAdmin:'
                    rules={[
                      {
                        required: true,
                        message: 'Please Select the SuperAdmin',
                      },
                    ]}
                  >
                    <Select
                      className='af-form-select af-isPrimaryDomain-form-select af-isPrimaryDomain-form-select-superAdmin'
                      showSearch
                      placeholder='Select the SuperAdmin Group'
                      allowClear
                    >
                      {dropDownGroupData &&
                        dropDownGroupData.map((group) => (
                          <Select.Option
                            className='af-form-select-option af-isPrimaryDomain-form-select-option'
                            key={group.distinguishedName}
                            value={group.distinguishedName}
                          >
                            {group.groupName}
                          </Select.Option>
                        ))}
                    </Select>
                  </FormLabel>
                  <FormLabel
                    className='af-form-button-submit-wrapper af-isPrimaryDomain-form-button-submit-wrapper'
                    style={{ textAlign: 'end' }}
                  >
                    <StyledButton
                      type='primary'
                      htmlType='submit'
                      className='af-form-button af-isPrimaryDomain-form-button af-isPrimaryDomain-form-button_submit'
                    >
                      Update
                    </StyledButton>
                  </FormLabel>
                </Form>
              </div>
            </Modal>
          )}
        </>
      ),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (_, record) => (
        <Space className='af-superadmin-domain-space-wrap'>
          <DomainSettingsModal {...record} />
          <UpdateDomainModal handlelogout={handlelogout} {...record} />
          <Tooltip title='Delete' color='#597081' className='af-superadmin-domain-delete-tooltip'>
            <SpanButton
              className='af-superadmin-domain-delete-tooltip-button'
              onClick={() => deleteDomainSweetAlert(record.id)}
            >
              <DeleteIcon className='af-superadmin-domain-delete-tooltip-icon' />
            </SpanButton>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <AdminPageWrap className='af-superadmin-domain-wrap'>
      <AdminPageSizeWrap className='af-superadmin-domain-content'>
        <BackButton className='af-superadmin-domain-backbutton' to='/'>
          <LeftArrowIcon className='af-superadmin-domain-leftarrow' /> Back
        </BackButton>
        <AdminTitleWrap className='af-superadmin-domain-title-wrap'>
          <h2 className='af-superadmin-domain-title-head'>Domains</h2>
          <div className='af-superadmin-domain-title-button-wrap'>
            <StyledButton
              type='primary'
              onClick={() => {
                if (parseInt(licenseDetails?.tierInfo) <= domainFromApi.length) {
                  SweetSweetAlert({
                    text: `You can only add ${licenseDetails.tierInfo} Active Directory domain(s) as per your license.`,
                    icon: 'info',
                    buttonColor: 'blue',
                  });
                } else {
                  Navigate('/create_domain');
                }
              }}
              className='af-superadmin-domain-title-button'
            >
              Add A Domain
            </StyledButton>
          </div>
        </AdminTitleWrap>
        {loader && <ModalOpenLoader />}
        <div className='af-superadmin-domain-table-wrap'>
          <TableComponent
            loading={{
              spinning: loading,
              indicator: <TableLoader />,
            }}
            columns={columns}
            data={dataToShow}
          />
        </div>
        <div className='af-superadmin-domain-pagination-wrap'>
          <CustomPagination
            totalItems={domainFromApi.length}
            currentPage={currentPage}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={setPageSize}
            pageSizeOptions={[30, 50, 100, 500]}
            startIndex={startIndex}
            endIndex={endIndex}
          />
        </div>
      </AdminPageSizeWrap>
    </AdminPageWrap>
  );
}

export default AdminPage;
